import React from 'react';
import { Card, Text } from '@mlc/web-ui-toolkit';
import {
	EpiAccount,
	FinancialPlanningSoftware,
} from '../../../../logic/domains/epi.domain';
import ActionLink from '../Common/ActionLink';

interface Props {
	enableEdit: boolean;
	account: EpiAccount;
	onModeChange?: () => any;
	forwardedRef?: any;
}

const ViewProductOptions = (props: Props) => {
	const Options = ({ products }: { products: FinancialPlanningSoftware[] }) => (
		<React.Fragment>
			{products
				.sort((a, b) => a.value.localeCompare(b.value))
				.map(p => (
					<Text key={p.value} marginBottom={3}>
						{p.value}
					</Text>
				))}
		</React.Fragment>
	);

	return (
		<React.Fragment>
			<Card display="flex" flex="1" flexDirection="column" paddingTop={1}>
				<Options products={props.account.fps} />
			</Card>
			<div>
				<ActionLink
					isActive={props.enableEdit}
					handler={() => {
						props.onModeChange && props.onModeChange();
					}}
					id="editFPSOptions"
					label="Edit Financial Planning Software selection"
					forwardedRef={props.forwardedRef}
				/>
			</div>
		</React.Fragment>
	);
};

export default ViewProductOptions;
